
import Vue from 'vue';
import { mapMutations } from 'vuex';
import Button from '@/components/Button/index.vue';
import Modal from '@/components/Modal/index.vue';
import { createReportTerm, CreateReportTermParams } from '@/services/territory/create-report-term';
import {
  AnswerType,
  UpdateReportTerm,
  updateReportTerm,
} from '@/services/territory/update-report-term';
import { getPayment } from '@/services/payments/get-payments';
import { updateStatusTerritoryOfficial } from '@/services/territory/update-status-territory-oficial';
import getTerritoryByCarCodeService from '@/services/territory/get-territory-by-car-code';
import { generateLinkGix, GenerateLinkGixParams } from '@/services/gix/generate-link-gix';
import updateUserVoucher from '@/services/territory-access/update-user-voucher-access';
import getUserVoucherAvailability from '@/services/territory-access/get-user-voucher-availability';

export default Vue.extend({
  components: {
    Button,
    Modal,
  },
  inject: [
    'userLogged',
    'resetStepsRegisterTerritory',
    'getStepDate',
    'changeStatusTerritoryCarRequest',
  ],
  data() {
    return {
      isLoading: false,
      isOpenModal: false,
      isLoadingInactive: false,
      isLoadingInactiveYes: false,
      isRefusal: false,
      msg: '',
      territoryByCar: {
        loaded: false,
        aderiuPRA: '',
        area: '',
        condigo: '',
        dataAnalise: '',
        dataRegistro: '',
        dataRetificacao: '',
        latitude: '',
        longitude: '',
        modulosFiscais: '',
        statusImovel: '',
        condicaoAnalise: '',
        estado: '',
      },
    };
  },
  methods: {
    ...mapMutations(['setVoucherUsability']),
    async onNextStep() {
      try {
        this.isLoading = true;
        this.updateReportTermRequest(AnswerType.accepted);
        await updateUserVoucher();
        const responseAvailability = await getUserVoucherAvailability();
        this.setVoucherUsability(responseAvailability.usabilityAvailable);
        await this.getPaymentRequest();
        this.changeStatusTerritoryCarRequest('PROVISORIO');
        this.getGenerateGixLinkRequest();
        this.isLoading = true;
        if (this.msg.indexOf('O território não possui detecções válidas para participar do programa') !== -1) {
          this.getStepDate.currentStep += 1;
        }
        updateStatusTerritoryOfficial(this.getStepDate.territory.id, 'PROVISORIO');
        this.getStepDate.currentStep += 1;
      } catch (err) {
        this.isLoading = false;
        this.resetStepsRegisterTerritory();
        this.getStepDate.isErrors = true;
      }
    },
    getGenerateGixLinkRequest() {
      const params: GenerateLinkGixParams = {
        TokenKey: this.userLogged.company.stKey,
        NameTerritory: this.getStepDate.territory.name,
        CdUser: this.userLogged.idUser,
        CdTerritory: this.getStepDate.territory.id,
        CdJourneyModel: 1,
        CdJourneyGroupModel: 1,
        CdJourneyGroupTaskModel: [1, 2, 3, 4],
      };

      generateLinkGix(params).then((data) => {
        this.getStepDate.gixUrl = data;
      });
    },
    async updateReportTermRequest(answer: AnswerType) {
      const params: UpdateReportTerm = {
        termId: this.getStepDate.term.termId,
        answer,
        tokenKey: this.userLogged.company.stKey,
      };

      const response = await updateReportTerm(params);

      if (response.hasErrors) {
        throw new Error();
      }
    },
    async createReportTermWithRetry(params: CreateReportTermParams, retries = 0, maxRetries = 5) {
      try {
        this.isLoadingInactiveYes = true;
        const response = await createReportTerm(params);
        if (response && !response.hasErrors) {
          this.isOpenModal = true;
          this.isLoadingInactiveYes = false;
          return response;
        }
        throw new Error('Erro na requisição: resposta não é válida.');
      } catch (error) {
        console.warn(`Tentativa ${retries + 1} falhou: ${error}`);
        if (retries < maxRetries) {
          // Aguarde antes de tentar novamente
          await new Promise((resolve) => setTimeout(resolve, 1000));
          return this.createReportTermWithRetry(params, retries + 1, maxRetries);
        }
        console.error('Número máximo de tentativas atingido.');
        throw error;
      }
    },
    async createReportTermRequest(condition: boolean) {
      const {
        stName, stDocument, stEmail, stPhone,
      } = this.userLogged;
      const strAdress = `${this.getStepDate.address.address}, ${this.getStepDate.address.neighborhood}`;
      const params: CreateReportTermParams = {
        // @ts-ignore
        nameMain: stName,
        document: stDocument,
        tokenKey: this.userLogged.company.stKey,
        cdTerritory: this.getStepDate.territory.id,
        carNumber: this.getStepDate.territory.car.replaceAll('-', ''),
        territoryName: this.getStepDate.territory.name,
        street: strAdress,
        number: this.getStepDate.address.number,
        complement: this.getStepDate.address.complement,
        city: this.getStepDate.address.city,
        state: this.getStepDate.address.state,
        cep: this.getStepDate.address.zipCode,
        email: stEmail,
        telephone: stPhone,
        // @ts-ignore
        cdAgent: this.getStepDate.agent.id,
        representativeName: this.getStepDate.territory.representative.name === '' ? 'Não informado' : this.getStepDate.territory.representative.name,
        representativeDocumentNumber: this.getStepDate.territory.representative.document !== undefined ? this.getStepDate.territory.representative.document : '0',
        representativePosition: this.getStepDate.territory.representative.office !== undefined ? this.getStepDate.territory.representative.office : 'Não informado',
        isAssing: condition,
      };
      try {
        const data = await this.createReportTermWithRetry(params);
        this.getStepDate.term = { ...this.getStepDate.term, ...data };
      } catch (error) {
        console.error('Erro ao criar o termo de compromisso:', error);
      }
    },
    async getPaymentRequest() {
      const { objectResult } = await getTerritoryByCarCodeService(this.getStepDate.territory.car.trim().replaceAll('-', ''));

      if (objectResult) this.territoryByCar = objectResult.dadosExtratoPdf;
      const { idUser } = this.userLogged;
      const params: any = {
        tokenKey: this.userLogged.company.stKey,
        cdTerritory: this.getStepDate.territory.id,
        fkUser: idUser.toString(),
        cdAnalysis: `${process.env.VUE_APP_ANALISE}`,
        cdCompany: this.userLogged.company.idCompany.toString(),
        taxModules: this.territoryByCar.modulosFiscais.toString(),
      };
      const response = await getPayment(params);
      this.msg = response.msg;

      this.getStepDate.penalty = { ...this.getStepDate.penalty, ...response };
      this.getStepDate.msg = { ...this.getStepDate.msg, ...response.msg };
    },
    resetValues() {
      this.isLoading = false;
      this.getStepDate.refs.car.reset();
      this.resetStepsRegisterTerritory();
    },
    openModalRefusal() {
      this.isRefusal = true;
    },
    returnHome() {
      this.$router.push('/produtor/territory');
    },
  },
  mounted() {
    // @ts-ignore
    if (sessionStorage.getItem('skip') === true) {
      this.onNextStep();
    }
  },
});
